import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { formattedNumber } from '../../../../../../utils/formatterHelpers';


const styles = theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '100%',
        flexShrink: 0,
        textTransform: 'capitalize',
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
});

class WhySolarPanels extends React.Component {
  state = {
      expanded: null,
  };

  handleChange = panel => (event, expanded) => {
      this.setState({
          expanded: expanded ? panel : false,
      });
  };

  render() {
      const { classes, terms } = this.props;
      const { expanded } = this.state;

      let smartYears = '10';
      if (terms.systemSize / 1000 > 25) {
          smartYears = '20';
      }

      const addedHomeValue = formattedNumber(terms.annualResults[1].annualSolarSavings * 18);
      let itcPercentage = 30;
      if (terms.installYear === 2020) {
          itcPercentage = 26;
      } else if (terms.installYear === 2021) {
          itcPercentage = 22;
      } else if (terms.installYear > 2021) {
          itcPercentage = 10;
      }

      let itcValue = terms.annualResults[1].itc;
      if (!terms.showLoan) {
          itcValue = terms.annualResults[1].cashITC;
      }

      let mosaicFinance = null;
      if (terms.resiToggle && terms.loanProvider === 'mosaic' && terms.showLoan) {
          mosaicFinance = 'If you finance your system with Mosaic, you may be eligible for a greater credit.';
      }
      const deprPercent = terms.annualResults[1].macrs / terms.price * 100;


      const percent = (terms.annualResults[30]
          .cumulativeIncentives +
          itcValue + terms.annualResults[1].macrs) / terms.price * 100;

      return (
          <div className={classes.root}>
              <ExpansionPanel expanded={expanded === 'panel2'} onChange={this.handleChange('panel2')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography className={classes.heading}>Your State and Solar Incentives total {formattedNumber(percent)}% of the price</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                      <Typography className="specsText">
                          <p>Solar is a no-brainer. Over the life of your PV solar-generating system, Renewable Energy Certificates (REC) State Incentive Programs can supply as much as {formattedNumber(percent)}% of the turnkey price of your Solvana designed and engineered PV solar-generating system. Ask your tax advisor how also best to use Investment Tax Credits (ITC), available Rebates, available Local Incentives, available Property Tax Abatements, and any IRS Section 179 Tax Depreciation.
                          </p>
                      </Typography>
                  </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel expanded={expanded === 'panel6'} onChange={this.handleChange('panel6')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography
                          className={classes.heading}
                      >
                          Are you eligible for a ${formattedNumber(itcValue)} federal investment tax credit?
                      </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                      <Typography className="specsText">
                          <p>

                              The Federal Investment Tax Credit (ITC) provides homeowners and businesses with a HUGE incentive to go solar! For solar-generating systems purchased in 2020, taxpayers are eligible for a  {itcPercentage}% dollar-for-dollar credit against federal tax owed in {terms.installYear}!  And, excess federal income tax credits can be carried forward to future years. That means, {terms.firstName}, you may be able to save as much as ${formattedNumber(itcValue)} in taxes in the first year!  {mosaicFinance} Check with your tax advisor to find out how you can utilize the ITC.
                          </p>
                      </Typography>
                  </ExpansionPanelDetails>
              </ExpansionPanel>
              {terms.projectState === 3 ?
                  <ExpansionPanel expanded={expanded === 'panel4'} onChange={this.handleChange('panel4')}>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}>New Jersey RECs give you  ${formattedNumber(terms.annualResults[15].cumulativeRecs)}</Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                          <Typography className="specsText">
                              <p>

                                  {terms.firstName}, in your first year, valuable State incentives referred to as Renewable Energy Credits (RECs) can put as much as ${formattedNumber(terms.annualResults[1].recs)}  in your pocket, which is like winning a valuable prize. RECs are a new source of income reserved for qualified NJ residents installing Solvana PV solar-generating systems. You can receive 1 REC for every 1,000 kilowatt-hours of PV solar-generating system electrical production, whether or not you use your electricity or simply credit the electricity to your electrical account through Net Metering. That means you can have your cake and eat it too! Utility companies buy your RECs to satisfy the NJ Renewable Portfolio Standard emission requirements. That is their best choice, as opposed to making Alternative Compliance Payments, which can cost them much more than merely buying your RECs. So, {terms.firstName}, as long as the sun rises each day, you can save money on the value of your generated electricity and also receive REC income for many years! RECs provide you with a powerful incentive to install your Solvana PV solar-generating system since the State of NJ guarantees REC income for 15-years. And, Solvana estimates that in 15 years, RECs can put about ${formattedNumber(terms.annualResults[15].cumulativeRecs)} directly into your pockets, which is like winning the lottery!
                              </p>
                          </Typography>
                      </ExpansionPanelDetails>
                  </ExpansionPanel>
                  : null }
              {terms.projectState === 4 ?
                  <ExpansionPanel expanded={expanded === 'panel9'} onChange={this.handleChange('panel9')}>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}>You get a ${formattedNumber(terms.annualResults[1].nyserdaRebate)} rebate from NYSERDA.</Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                          <Typography className="specsText">
                              <p>New York City NYSERDA customers acquiring a Solvana PV solar-generating system may be eligible to receive a one-time upfront rebate from NYSERDA. Solvana calculates that your estimated NYSERDA rebate is valued at ${formattedNumber(terms.annualResults[1].nyserdaRebate)}. And, Solvana includes processing your NYSERDA rebate application as part of our turnkey service! Please note that NYSERDA calculations are subject to approval and modification.
                              </p>
                          </Typography>
                      </ExpansionPanelDetails>
                  </ExpansionPanel>
                  : null }
              {terms.projectState === 4 ?
                  <ExpansionPanel expanded={expanded === 'panel10'} onChange={this.handleChange('panel10')}>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}>  A NYC Property Tax Abatement worth ${formattedNumber(terms.annualResults[1].cashNYAbatement * 4)}.</Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                          <Typography className="specsText">
                              <p>The Solar Electric Generating System (SEGS) New York City Property Tax Abatement delivers a powerful incentive to property owners that install a Solvana PV solar-generating system. The Property Tax Abatement provides property owners with a 4-year property tax reduction of 5% of the installed system’s cost per year up to 20%. Also, the Property Tax Abatement may not exceed your property tax liability in any single year. Additionally, the cap on the Property Tax Abatement is $62,500 per year or $250,000 in total. And lastly, eligible costs include equipment and components, design, schematics, permits, and installation labor.
                              </p>
                              <p>
                                  And as part of our turnkey service, Solvana shows you how to process your NYC Property Tax Abatement application with the NYC Department of Buildings!
                              </p>
                              <p>
                                  We estimate your abatement could be worth  ${formattedNumber(terms.annualResults[1].cashNYAbatement * 4)}. If you are interested in taking advantage of the NYC Property Tax Abatement, then please act quickly! The Property Tax Abatement Program has been successful for more than a decade but is ending January 1, 2021. So, hurry since these savings are only available for a short time longer!
                              </p>
                          </Typography>
                      </ExpansionPanelDetails>
                  </ExpansionPanel>
                  : null }
              {terms.projectState === 4 && terms.resiToggle ?
                  <ExpansionPanel expanded={expanded === 'panel11'} onChange={this.handleChange('panel11')}>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}> A NY State Tax Credit of ${formattedNumber(terms.annualResults[1].nyResiTaxCredit)}</Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                          <Typography className="specsText">
                              <p> New York State residents purchasing or leasing a solar-generating system are eligible for a New York State Personal Gross Income Tax Credit if meeting the following criteria:
                              </p>
                              <p>
                                  <ul>
                                      <li>purchased solar-generating equipment</li>
                                      <li>entered into a written agreement for the lease of solar-generating system equipment, or</li>
                                      <li>entered into a written contract that spans at least 10-years for the purchase of energy generated by solar-generating system equipment not owned by you</li>
                                  </ul>
                              </p>
                              <p>
                                  The credit is equal to 25% of the cost of your qualified solar-generating system and is limited to $5,000. To claim the New York State Personal Tax Credit, you must install your solar-generating system at your private residence. Community Solar, which the State of New York defines as PV solar-generated electricity shared by more than one property, is not eligible for the New York State Personal Tax Credit.

                              </p>
                          </Typography>
                      </ExpansionPanelDetails>
                  </ExpansionPanel>
                  : null }
              {terms.projectState === 2 ?
                  <ExpansionPanel expanded={expanded === 'panel5'} onChange={this.handleChange('panel5')}>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}>Solar Massachusetts Renewable Target (SMART) Program</Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                          <Typography className="specsText">
                              <p>
                                  The Massachusetts Department of Energy Resources (DOER), in conjunction with electrical utilities Eversource, National Grid, and Unitil, set their sights on MA becoming the most energy-efficient state in the USA by launching the Solar Massachusetts Renewable Target (SMART) Program. Intended to be a long-term and sustainable Incentive Program, SMART credits encourage the development of PV solar-generating systems by supporting 1,600 MW of new capacity.
                              </p>
                              <p>
                                  Your SMART incentive rate is estimated to be {terms.smartValue} per kilowatt-hour (kWh) produced by your Solvana PV solar-generating system over the next {smartYears} years. This amount can be paid to you either by check or directly deposited into your bank account! In the first year alone, your SMART Incentive is estimated to be worth ${formattedNumber(terms.annualResults[1].smart)}!
                              </p>
                              <p>
                                  Current Solar Massachusetts Renewable Target (SMART) Program participants are eligible to receive SMART Incentives. Statement of Qualification Forms, which display actual SMART Incentive Payment (SIP) Rates, are provided by the Massachusetts Department of Energy Resources. SIP Rates are fixed for the duration of their tariff terms, remain constant, and are not speculative now as they were under an earlier MA REC Incentive Program! The steady and reliable stream of income from SMART makes them Bankable and a significant improvement over any of the old REC Programs.
                              </p>
                              <p>
                                  The information generated by the MA SMART Program Incentive Calculator tool is derived from several sources, including available utility rate information, DOER&apos;s Guideline on Capacity Blocks, Base Compensation Rates, and Compensation Rate Adders. The MA SMART Program Incentive Calculator is intended to approximate SIP Rate Estimates and is for estimating purposes only. Neither Department of Energy Resources nor the Electric Distribution Companies make any warranties or representations, expressed or implied, as to the usefulness, completeness, or accuracy of the information contained, described, disclosed, or referred to in this tool.
                              </p>
                          </Typography>
                      </ExpansionPanelDetails>
                  </ExpansionPanel>
                  : null }
              {terms.projectState === 2 && terms.resiToggle ?
                  <ExpansionPanel expanded={expanded === 'panel14'} onChange={this.handleChange('panel14')}>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}>
                              $1,000 MA Residential Renewable Energy Income Tax Credit
                          </Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                          <Typography className="specsText">
                              <p>
                                  When it comes to clear cut state solar incentives, it doesn’t get much simpler than the Massachusetts Residential Renewable Energy Income Tax Credit. This financial incentive offers a tax credit of 15 percent of the net cost of your solar-generating system. MA caps this dollar-for-dollar tax credit at a maximum of $1,000 that you can receive against your MA state income tax.
                              </p>

                          </Typography>
                      </ExpansionPanelDetails>
                  </ExpansionPanel>
                  : null }
              {terms.projectState === 2 && terms.resiToggle ?
                  <ExpansionPanel expanded={expanded === 'panel13'} onChange={this.handleChange('panel13')}>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}>
                              MA Solar Generating System Tax Exemptions
                          </Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                          <Typography className="specsText">
                              <p>
                                  When investing in a solar-generating system with Solvana, you should not have to pay property taxes on the increased value to your property. In October 2008, the State of New Jersey, along with many other States, enacted legislation exempting PV solar-generating systems that supply on-site electricity from local property tax increases. You may claim property tax exemptions for all qualified PV solar-generating systems installed on residential, commercial, industrial, or mixed-use buildings as accessory uses. To claim your property tax exemption, you must apply for a property exemption certificate (<a href="https://www.state.nj.us/treasury/taxation/pdf/other_forms/lpt/cres.pdf" target="_blank" rel="noopener noreferrer"s>Application for Certification of Renewable Energy Systems</a>) from your local tax assessor. Your tax assessor can reduce the assessed value of your property to what it would be without the cost of the PV solar-generating system. Exemptions can take effect as early as the year after your tax assessor grants your certification. Please direct questions about the property tax exemption to your local tax assessor.
                              </p>

                          </Typography>
                      </ExpansionPanelDetails>
                  </ExpansionPanel>
                  : null }
              {terms.projectState === 3 && terms.resiToggle ?
                  <ExpansionPanel expanded={expanded === 'panel13'} onChange={this.handleChange('panel13')}>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}>
                              New Jersey Property tax exemption
                          </Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                          <Typography className="specsText">
                              <p>
                                  The State of New Jersey offers Sales Tax exemptions for all NJ PV solar-generating system installations, which are available to all State residents. That means you will spend less money on your PV solar-generating system. To claim your NJ State Sales Tax exemption, please complete, sign, and submit the <a target="_blank" rel="noopener noreferrer" href="http://www.state.nj.us/treasury/taxation/pdf/other_forms/sales/st4.pdf">State of New Jersey, Division of Taxation, Sales Tax, Form ST-4</a>, Exempt Use Certificate to
                                  <a href="mailto:AP@solvana.io" rel="noreferrer" > AP@Solvana.io
                                  </a>.
                              </p>

                          </Typography>
                      </ExpansionPanelDetails>
                  </ExpansionPanel>
                  : null }
              {terms.resiToggle === false ?
                  <ExpansionPanel expanded={expanded === 'panel7'} onChange={this.handleChange('panel7')}>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}>Your Section 179 Depreciation</Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                          <Typography className="specsText">
                              <p>
                                  You may be eligible to expense  ${formattedNumber(terms.price * 0.87)} of your system price from your Gross Income in the 1st year. In your Income Tax Rate Bracket of {terms.taxRate}%, this deduction is worth a cool ${formattedNumber(terms.annualResults[1].macrs)} in cash to you, or about {formattedNumber(deprPercent)}% of the installed price right back to you Y1! Under Section 179 of the IRS Tax Code, businesses can expense or deduct the full purchase price of qualifying equipment and software from their gross income taxes, rather than requiring the cost of the property to be capitalized and depreciated over its useful life.
                              </p>

                          </Typography>
                      </ExpansionPanelDetails>
                  </ExpansionPanel>
                  : null }
              {terms.loanProvider === 'mosaic' && terms.resiToggle ?
                  <ExpansionPanel expanded={expanded === 'panel8'} onChange={this.handleChange('panel8')}>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}>
                              Mosaic Financing Makes it easy to go Solar
                          </Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                          <Typography className="specsText">
                              <p>
                                  {terms.firstName}, Solvana is proud to offer you a Solar Mosaic™ solar-generating system loan for your home. Since 2010, there has been a huge leap forward in residential solar financing. Solar Mosaic™ is a leader in financing PV solar. Solar Mosaic™ gets credit for financing approximately 50% of all of the PV solar loans issued in the entire USA during the first half of 2019. Customers love Solar Mosaic™ for three main reasons: 1) it is easy to enroll; 2) flexible terms including no prepayment penalty; 3) there is no lien placed on your home. Please note: All Solar Mosaic™ loan dates, amounts, terms, and rates found in the Solvana Proposal are only estimates. The Solar Mosaic™ Loan Closing Certificate provided by Solar Mosaic™ contains the actual dates, amounts, terms, and rates. Also, the Solvana App Proposal assumes you enroll in autopay with Solar Mosaic™, because it lowers your interest rate by 0.25%.

                              </p>
                          </Typography>
                      </ExpansionPanelDetails>
                  </ExpansionPanel>
                  : null }
              {terms.resiToggle ?
                  <ExpansionPanel expanded={expanded === 'panel12'} onChange={this.handleChange('panel12')}>
                      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography className={classes.heading}>
                              Solar Can Add ${addedHomeValue} to the Value of Your Home
                          </Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                          <Typography className="specsText">
                              <p>
                                  A US Department of Energy study finds that your solar-generating system adds 18 times the value of the 1st year’s solar electricity generation to the value of your home or business. When you consider all of the State and Local Incentives you receive from installing your solar-generating system with Solvana, the value of your home or business should be significantly higher than before you install solar. Also, keep in mind that the State designates PV solar as being <em>&rdquo;Beneficial to Society,&ldquo;</em> so many States prevent municipalities from increasing property taxes for solar- generating system improvements by law!
                              </p>
                          </Typography>
                      </ExpansionPanelDetails>
                  </ExpansionPanel>
                  : null }
          </div>
      );
  }
}

WhySolarPanels.propTypes = {
    classes: PropTypes.object.isRequired,
    terms: PropTypes.object.isRequired,
};

export default withStyles(styles)(WhySolarPanels);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/WHYGOSOLAR/WhySolarPanels.js